export default __webpack_public_path__ + "d7bc712cf4713f15ad3885d223f631a9.png";